/** --------------------------------------------------------
* Author Tien Tran
* Email tientran0019@gmail.com
* Phone 0972970075
*
* Created: 2024-07-29 01:19:14

* Last updated on: 2024-07-29 01:19:14
* Last updated by: Tien Tran
*------------------------------------------------------- */

'use client';

import { useDebounce } from 'react-use';
import React, { memo, useEffect } from 'react';

import { TextField, InputAdornment, FilledTextFieldProps } from '@mui/material';

import { Iconify } from '@onair/minimal-ui/iconify';

type PropTypes = Partial<FilledTextFieldProps> & {
	value: string;
	onSearch: (v: string) => void;
	minLengthToSearch?: number;
};

const InputSearch: React.FC<PropTypes> = ({
	value = '',
	onSearch,
	minLengthToSearch = 4,
	...others
}) => {
	const [searchQuery, setSearchQuery] = React.useState(value ?? '');

	useEffect(() => {
		if (value !== searchQuery) {
			setSearchQuery(value);
		}
	}, [value]);
	useDebounce(
		() => {
			if (
				value !== searchQuery
				// || searchQuery?.length >= minLengthToSearch
			) {
				onSearch(searchQuery);
			}
		},
		1500,
		[searchQuery],
	);
	return (
		<TextField
			size="medium"
			value={searchQuery}
			// defaultValue={value ?? ""}
			placeholder="Tìm kiếm..."
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Iconify icon="eva:search-fill" />
					</InputAdornment>
				),
			}}
			sx={{
				width: {
					xs: '100%',
				},
			}}
			{...others}
			onChange={(e) => {
				setSearchQuery(e.target.value);
			}}
		/>
	);
};

export default memo(InputSearch);
